import React from "react";
import API from "../../../api/index";
import { Typography, TextField, Button, Box, Switch, FormControlLabel, Stack, MenuItem } from "@mui/material";
import { useState } from "react";
import { btnStyle } from "../../../theme";
import { startToast, updateToastSuccess, updateToastError } from '../../../utils/notification-loading';

const AddLecsCard = ({licenses}) => {
  const [matricola, setMatricola] = useState("");
  const [errorMatricola, setErrorMatricola] = useState(false);
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [privacy, setPrivacy] = useState(false);
  const [license, setLicense] = useState("");


  /* const handleChangePrivacy = () => {
    if (notChecked === false) {
      setNotChecked(true);
      setPrivacy(1);
    } else {
      setNotChecked(false);
      setPrivacy(0);
    }
  };

  const handleSubmit = (event) => {
    startToast();
    event.preventDefault();
    API.postAddLecs({
      serial_number: matricola,
      name: name,
      location: location,
      privacy: privacy,
    })
      .then((response) => {
        //window.location.reload();
        updateToastSuccess("Your Lecs has been correctly added. Wait while the LECS ecosystem is loaded, you will now be redirected to the Login-Page")
        setTimeout(() => {
          API.logout({})
            .then(() => {
              window.sessionStorage.removeItem("selectedTab");
              navigate("/");
            })
            .catch(() => {
              window.sessionStorage.removeItem("selectedTab");
              navigate("/");
            });
        }, 5000)
      })
      .catch((error) => {
        
        updateToastError("Error During Insertion");
      });
  }; */

  const handleAdd = () => {
    startToast();
    API.addLecs({
      matricola: matricola,
      nome: name,
      sede: location,
      privacy: privacy,
      licenza: license
    }).then((res) => {
      updateToastSuccess("You added a new LECS");
      setMatricola("");
      setName("");
      setLocation("");
      setPrivacy(false);
      setLicense("");
    }).catch((err) => {
      updateToastError(err.response.data.err);
    })
  }    

  const handleChangeMatric = (e) => {
    let value = e.target.value.toUpperCase();
    value = value.replace(/[^A-Z0-9-]/g, '');
    value = value.replace(/-+/g, '-');
    if (value.length > 2 && value.charAt(2) !== '-') value = value.slice(0, 2) + '-' + value.slice(2);
    if (value.length > 7) value = value.slice(0, 7);
    setMatricola(value);
    if(/^[A-Z][0-9]-[0-9]{4}$/.test(value) || value === "") setErrorMatricola(false);
    else setErrorMatricola(true);
  };
  
  return (
    <Box sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 3
    }}>
      <Typography variant="h4">Add new LECS</Typography>
      <Stack direction={"row"} spacing={2} width={"80%"}>
        <TextField
          label="Serial Number"
          placeholder="XX-XXXX"
          fullWidth
          value={matricola}
          onChange={handleChangeMatric}
          error={errorMatricola}
        />
        <TextField
          label="Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          label="Location"
          fullWidth
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
      </Stack>
      <FormControlLabel
        control={<Switch
          checked={privacy}
          onChange={(e) => setPrivacy(e.target.checked)}
        />}
        label="Want you to allow the reseller to see your LECS "
      />
      <Typography variant="h4">Select the license to which you want to add the LECS</Typography>
      <TextField
        select
        label="License"
        sx={{width: "50%"}}
        value={license}
        onChange={(e) => setLicense(e.target.value)}
      >
        {licenses.map((license) => (
          <MenuItem value={license.codiceAttivazione}>
            {license.codiceAttivazione}
          </MenuItem>
        ))}
      </TextField>
      <Button sx={btnStyle} onClick={handleAdd}>
        ADD LECS
      </Button>
    </Box>
  );
};

export default AddLecsCard;